<template>
    <div class="preRebate">
      <div class="preRebate_cont"></div>
      <div class="preRebate_footer"></div>
    </div>
  </template>
  <script>
  import { mapState } from 'vuex';
  import { getUrlParams } from '@/utils';
  import server from '@/server/index';
  import store from '@/store';
  export default {
    data() {
      return {
        showGame: false,
        linkUrl: '',
      };
    },
    computed: {
    },
    created() {
        console.log('aaaa')
    },
    methods: {
      closeUserLink() {
        this.linkUrl = '';
      },
    },
  };
  </script>
  <style>
  .preRebate {
    width: 100%;
    height: 100vh;
    background: #fff;
  }
  .preRebate_footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: url(../assets/imgs/preRB_foot.png) no-repeat;
    background-size: 100% 100%;
  }
  </style>
  